import Draft from "draft-js";
import { getEntityDataByType } from "./getEntityDataByType";

/**
 * Get a list of all mentioned user IDs
 */
export const getUserMentionIds = (content: Draft.ContentState) => {
  const ids = getEntityDataByType(content, "USER_MENTION").reduce(
    (acc, userMentionEntity) => {
      const userId = userMentionEntity.data?.userId;
      if (typeof userId === "string" && userId.startsWith("User|"))
        return [...acc, userId];

      return acc;
    },
    [] as string[],
  );
  return ids;
};
